import { render, staticRenderFns } from "./menuPanel.vue?vue&type=template&id=77042240&lang=pug"
import script from "./menuPanel.vue?vue&type=script&lang=js"
export * from "./menuPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports